//

export const CARGOS_GET_COSTO_INSCRIPCION = "cargos/COSTO_INSCRIPCION"
export const CARGOS_GET_COSTO_INSCRIPCION_SUCCESS =
  "cargos/COSTO_INSCRIPCIONSUCCESS"
export const CARGOS_GET_COSTO_INSCRIPCION_FAIL = "cargos/COSTO_INSCRIPCIONFAIL"

export const CARGOS_GET_COSTO_COLEGIATURA = "cargos/COSTO_COLEGIATURA"
export const CARGOS_GET_COSTO_COLEGIATURA_SUCCESS =
  "cargos/COSTO_COLEGIATURASUCCESS"
export const CARGOS_GET_COSTO_COLEGIATURA_FAIL = "cargos/COSTO_COLEGIATURAFAIL"
